module.exports = __webpack_public_path__ + "img/gallery-img-4s.92446369.jpg";